import React from 'react';

import Feature from '../Feature';
import { useTranslations } from 'components/utilities';
import { FullInsuranceIcon } from '../../styles';

const InsuranceFeature = () => {
	const { t } = useTranslations();
	return (
		<Feature
			header={<FullInsuranceIcon />}
			title={t('common.CDWInsurance')}
		/>
	);
};

export default InsuranceFeature;
